import { jsx } from "react/jsx-runtime";
import "@flatfile/design-system";
import "react";
import "../Default/Styles.js";
import Renderer$1 from "../Default/Renderer.js";
const Renderer = (props) => {
  return /* @__PURE__ */ jsx(Renderer$1, { ...props, number: true });
};
export {
  Renderer as default
};
